import React from "react";
import { Card, CardContent, Typography, Collapse, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const ViewPastEvaluations = ({ evaluation }) => {
  const [openPastEvaluation, setOpenPastEvaluation] = React.useState(false);

  const latestEvaluation = evaluation?.history?.[evaluation.history.length - 1];
  const remainingEvaluations = evaluation?.history;

  const renderEvaluationItem = (item, index) => {
    const startTime = new Date(item.start_time);
    const endTime = new Date(item.end_time);
    const timeDiffMs = endTime - startTime;
    const timeDiffSec = timeDiffMs / 1000;

    return (
      <Card
        key={item.id || index}
        variant="outlined"
        sx={{
          bgcolor: "background.paper",
          boxShadow: 1,
          mb: 1,
        }}
      >
        <CardContent>
          <Typography variant="subtitle1">
            Status: <strong>{item.status}</strong>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Created By: {item.createdBy}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Date: {new Date(item.date).toLocaleString()}
          </Typography>

          {(item.status !== "Re-Evaluation Requested" ||
            item.status !== "Dispute Requested") && (
            <Typography variant="body2" color="textSecondary">
              Time Tracking: {timeDiffSec.toFixed(0)} seconds
            </Typography>
          )}

          {(item.status === "Re-Evaluation Requested" ||
            item.status === "Dispute Requested") && (
            <Typography variant="body2" color="textSecondary">
              Reason: {item.reason}
            </Typography>
          )}

          {item.status === "Evaluation Moved" && (
            <Typography variant="body2" color="textSecondary">
              Move History: <strong>{item.reason}</strong>
            </Typography>
          )}
        </CardContent>
      </Card>
    );
  };

  return (
    <div>
      <Card>
        <CardContent>
          <Typography sx={{ mb: 1 }}>Evaluation History</Typography>
          {latestEvaluation ? (
            renderEvaluationItem(latestEvaluation, 0)
          ) : (
            <Typography variant="body2" color="textSecondary">
              No History
            </Typography>
          )}
        </CardContent>

        {remainingEvaluations?.length > 0 && (
          <>
            <Button
              fullWidth
              onClick={() => {
                setOpenPastEvaluation(!openPastEvaluation);
              }}
            >
              {openPastEvaluation ? "Hide all history" : "View All History"}
            </Button>

            <Collapse in={openPastEvaluation}>
              <DataGrid
                columns={[
                  { field: "status", headerName: "Status", width: 200 },
                  { field: "createdBy", headerName: "Created By", width: 200 },
                  { field: "date", headerName: "Date", width: 200 },
                  {
                    field: "timeTracking",
                    headerName: "Time Tracking",
                    width: 200,
                  },
                  { field: "reason", headerName: "Reason", width: 200 },
                ]}
                rows={remainingEvaluations
                  ?.sort((a, b) => new Date(a.date) - new Date(b.date))
                  .map((item, index) => ({
                    id: item.id || index,
                    status: item.status,
                    createdBy: item.createdBy,
                    date: new Date(item.date).toLocaleString(),
                    timeTracking: item.timeTracking,
                    reason: item.reason,
                  }))}
              />
            </Collapse>
          </>
        )}
      </Card>
    </div>
  );
};

export default ViewPastEvaluations;
